export function getDataUrlSizeInBytes(dataUrl: string) {
  const base64 = dataUrl.split(',')[1] ?? '';
  const padding = (base64.match(/=+$/) ?? [''])[0].length;
  return (base64.length * 3) / 4 - padding;
}
